<template>
    <el-dialog v-dialogDrag class="selDialog" width="1000px"
               :visible.sync="dialogVisible"
               append-to-body
               @close="close" center>
        <div slot="title">
            <div class="dialog_title">
                会计科目选择
            </div>
        </div>
        <div class="dialog_body">
            <div style="padding: 10px;height: 40px;margin-bottom:20px">
                <searchBar :searchData="searchData" @search="search">
                </searchBar>
            </div>
            <el-table
                    ref="treeTable"
                    :data="dataList"
                    height="400"
                    style="width: 100%;"
                    highlight-current-row
                    :header-cell-style="headerStyle"
                    :cell-style="cellStyle"
                    row-key="id"
                    @row-click="selRow"
                    default-expand-all
                    :tree-props="{children: 'children', hasChildren: 'hasChildren' ,disabled: 'disabled'}">
                    border>
                <el-table-column
                        type="index"
                        width="50">
                </el-table-column>
                <el-table-column
                        prop="code"
                        label="会计科目编码"
                        width="200">
                </el-table-column>
                <el-table-column
                        prop="name"
                        label="会计科目名称"
                        width="400">
                </el-table-column>
                <el-table-column
                        prop="accTitleType"
                        label="会计科目类别"
                        width="150">
                </el-table-column>
                <el-table-column
                        prop="accTitleKind"
                        label="会计科目标识"
                        width="100">
                </el-table-column>
            </el-table>
        </div>
    </el-dialog>
</template>

<script>
    import searchBar from '@/components/tools/toolBar/searchBar/build'

    export default {
        name: "selRole",
        props: ['accTitleData', 'loading'],
        components:{
            searchBar
        },
        data() {
            return {
                searchData: {
                    fields: [{
                        tag: "el-input",
                        label: "会计科目名称",
                        vModel: "accTitleName",
                    }],
                    formData: {
                        accTitleName: ""
                    },
                },
                dialogVisible: true,
                dialoading: false,
                dataList: [],
            }
        },
        async mounted() {
            await this.getListData();
            if(this.accTitleData){
                this.defaultSelect();
            }
        },
        methods: {
            headerStyle() {
                return "text-align:center;height:45px;line-hight:45px;padding: 1px 0;background-color:#f2f2f2;border-left:1px solid #e5e6e8;border-top:1px solid #e5e6e8;border-bottom:1px solid #e5e6e8"
            },
            cellStyle() {
                return "text-align:left"
            },
            close() {
                this.$emit('closeDialog', this.dialogVisible)
            },
            async search(){
                this.pageInfo.page = 1;
                await this.getListData();
            },
            async getListData() {
                this.dialoading = true;
                let param = {
                    url: "/accountingtitle/selZTree",
                    param: {
                    }
                }
                const data = await this.$store.dispatch('pubMethod', param)
                if (data.infoCode == '0') {
                    this.dataList = data.data.jsonStr;
                }
                this.dialoading = false;
            },
            selRow(row){
                this.$emit("checkRow",row);
            },
            //默认选中
            defaultSelect() {
                this.$nextTick(() => {
                    this.defaultChild(this.dataList)
                });
            },

            defaultChild(list){
                for(let i=0;i<list.length;i++){
                    if(this.accTitleData.accTitleId){
                        if(list[i].id == this.accTitleData.accTitleId){
                            this.$refs.treeTable.setCurrentRow(list[i]);
                            return;
                        }
                    }
                }
            },

            toPage(obj) {
                this.getListData();
            },
        },
    }
</script>

